import { render, staticRenderFns } from "./DiscussionInfo.vue?vue&type=template&id=d6fe569c&"
import script from "./DiscussionInfo.vue?vue&type=script&lang=js&"
export * from "./DiscussionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports